import { Injectable, OnDestroy } from '@angular/core';

import { TreeNode } from 'primeng/api';

import { JournodexRegionsService } from '../../../Common/Journodex/services/journodex-regions.service';
import { IncludeOrExclude } from '../../../Common/Dialogs/services/data-select-dialog.service.interface';
import { CountryApiModel } from '../../../api/journodex/model/country-api.model';
import { AbstractDataSelectDialogService } from '../../../Common/Dialogs/services/abstract-data-select-dialog.service';
import { LocalizationService } from '../../../Core/Localization/services/localization.service';


export const countryTreeNodeType: string = 'Country';

@Injectable()
export class PreferenceCountrySelectDialogService extends AbstractDataSelectDialogService<CountryApiModel> implements OnDestroy {

    constructor(
        protected localizationService: LocalizationService,
        private geographyService: JournodexRegionsService,
    ) {
        super(countryTreeNodeType, 'AMT.broadcast.countries.header', true);

        this.subscriptions.push(
            this.geographyService.getAllCountries().subscribe(countries => {
                this.treeNodes = this.convertDataToTreeNodes(countries);
                this.treeNodesProvider.next(this.treeNodes);
            })
        );
    }

    prepareData(state: IncludeOrExclude, countryIds: string[]) {
        this.geographyService.getCountriesByIsoCodes(countryIds).subscribe(countries => {
            this.selectedItems = countries;
            this.setData(state);
        });
    }

    prepareModelData(state: IncludeOrExclude, countries: CountryApiModel[]) {
        this.selectedItems = countries;
        this.setData(state);
    }


    /**
     * Converts country model array to TreeNode array and sorts alphabetically
     *
     * @param countries the models to convert
     *
     * @returns TreeNode[]
     */
    protected convertDataToTreeNodes(countries: CountryApiModel[]): TreeNode[] {
        const convertedArray: TreeNode[] = countries.map(country => {
            return ({
                label: country.name,
                data: country,
                type: countryTreeNodeType
            });
        }) ?? [];

        return convertedArray.sort(this.sortTreeItemsAlphabetically);
    }

    protected mapSelectedDataToNodes(countries: CountryApiModel[]): TreeNode[] {
        const convertedArray: TreeNode[] = countries
            .map(country => this.treeNodes.find(node => country.id === node.data.id))
            .filter(Boolean) ?? [];

        return convertedArray.sort(this.sortTreeItemsAlphabetically);
    }

    ngOnDestroy() {
        this.subscriptions.forEach(sub => sub.unsubscribe());
    }
}
